import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

function hasPermissionsForForms(forms, permissions, areOnlineForms) {
  if (!permissions || permissions.length <= 0) {
    return false;
  }

  if (!forms || forms.length <= 0) {
    return true;
  }

  const hasCompletePermission = areOnlineForms ? AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteCompleteForms]) : AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteCompleteForms]);
  const hasReviewPermission = areOnlineForms ? AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteInReviewForms]) : AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteInReviewForms]);

  if (!hasCompletePermission && !hasReviewPermission) {
    return false;
  }

  const completeForms = forms.filter(f => f.workflowStatus?.trim().toLowerCase().includes('complete'));
  const underReviewForms = forms.filter(f => !f.workflowStatus?.trim().toLowerCase().includes('complete'));

  if ((completeForms && completeForms.length > 0 && !hasCompletePermission) || (underReviewForms && underReviewForms.length > 0 && !hasReviewPermission)) {
    return false;
  }

  return true;
}

export default function CanDeleteAllFormsInSelection(forms, permissions) {
  if (!forms || forms.length <= 0) {
    return true;
  }

  if (!permissions || permissions.length <= 0) {
    return false;
  }

  const hasDeleteOnlineCompletePermission = AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteCompleteForms]);
  const hasDeleteOnlineReviewPermission = AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteInReviewForms]);
  const hasDeleteScannedCompletePermission = AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteCompleteForms]);
  const hasDeleteScannedReviewPermission = AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteInReviewForms]);

  if (hasDeleteOnlineCompletePermission && hasDeleteOnlineReviewPermission && hasDeleteScannedCompletePermission && hasDeleteScannedReviewPermission) {
    return true;
  }

  const onlineForms = forms.filter(f => f.isOnlineForm);
  const scannedForms = forms.filter(f => !f.isOnlineForm);

  let hasOnlinePermissions = false;
  let hasScannedPermissions = false;

  if (onlineForms.length > 0) {
    hasOnlinePermissions = hasPermissionsForForms(onlineForms, permissions, true);
  } else {
    hasOnlinePermissions = true;
  }

  if (scannedForms.length > 0) {
    hasScannedPermissions = hasPermissionsForForms(scannedForms, permissions, false);
  } else {
    hasScannedPermissions = true;
  }

  return hasOnlinePermissions && hasScannedPermissions;
}
